import React, { Suspense } from 'react';
import { importRemote } from 'module-federation-import-remote';
import { PageLoading } from '@dtna/dvs-core-dcp-ui-libraries';
import { getMfeUrl } from '@dtna/dvs-core-dcp-client-utils/lib/utils/mfe';
import { mfeLazyLoadFatalErrorHandler } from '../../utils/mfe';

const RemoteUpdatesPremium = React.lazy(() => importRemote<any>({
  url: getMfeUrl('REMOTE_UPDATES_PREMIUM'),
  scope: 'RemoteUpdatesPremium',
  module: 'App',
  bustRemoteEntryCache: false,
}).catch(mfeLazyLoadFatalErrorHandler));

export default function RemoteUpdatesPremiumWrapper({ navbarLoaded }: { navbarLoaded: boolean }) {
  return (
    <Suspense fallback={<PageLoading navbarLoaded={navbarLoaded} />}>
      <RemoteUpdatesPremium />
    </Suspense>
  );
}
